import { useState } from "react";
import { useSessao } from "@/sessao/useSessao";
import { useCriarPlano } from "@/api/consultas";
import { textoDoErro } from "@/api/problema";
import { ModalDeCadastro } from "@/componentes/ModalDeCadastro";
import { useAvisos } from "@/componentes/Avisos";
import { FormularioDePlano } from "./FormularioDePlano";
import {
  VALORES_INICIAIS,
  campoRecusado,
  corpoDaCriacao,
  validarPlano,
  type CampoDoPlano,
  type ErrosDoPlano,
  type ValoresDoPlano,
} from "./plano";

/*
 * Cadastro de plano.
 *
 * O plano nasce disponível e sem contrato: ele só passa a valer para uma
 * aplicação pela aba Contrato do detalhe dela.
 */
export function NovoPlano({ aberto, aoFechar }: { aberto: boolean; aoFechar: () => void }) {
  const { cliente } = useSessao();
  const avisos = useAvisos();
  const criar = useCriarPlano(cliente);

  const [valores, setValores] = useState<ValoresDoPlano>(VALORES_INICIAIS);
  const [erros, setErros] = useState<ErrosDoPlano>({});
  const [erroGeral, setErroGeral] = useState<string | undefined>(undefined);

  function mudar(campo: CampoDoPlano, valor: string) {
    setValores((atuais) => ({ ...atuais, [campo]: valor }));
    // O erro do campo some quando o operador mexe nele: continuar vermelho
    // depois da correção diria que a correção não serviu.
    setErros((atuais) => ({ ...atuais, [campo]: undefined }));
  }

  function fechar() {
    setValores(VALORES_INICIAIS);
    setErros({});
    setErroGeral(undefined);
    aoFechar();
  }

  function enviar() {
    setErroGeral(undefined);
    const validacao = validarPlano(valores);
    if (!validacao.ok) {
      setErros(validacao.erros);
      return;
    }

    criar.mutate(corpoDaCriacao(validacao.plano), {
      onSuccess: () => {
        avisos.feito("Plano cadastrado");
        fechar();
      },
      onError: (falha) => {
        // A recusa que aponta um campo vai PARA o campo; a que não aponta fica
        // acima dos botões. Mostrar nos dois lugares repetiria a frase.
        const campo = campoRecusado(falha);
        if (campo !== null) setErros({ [campo]: textoDoErro(falha) });
        else setErroGeral(textoDoErro(falha));
      },
    });
  }

  return (
    <ModalDeCadastro
      aberto={aberto}
      aoFechar={fechar}
      titulo="Novo plano"
      aoEnviar={enviar}
      enviando={criar.isPending}
      erro={erroGeral}
    >
      <FormularioDePlano valores={valores} erros={erros} aoMudar={mudar} />
    </ModalDeCadastro>
  );
}
